//  ----------      START   IMPORT  BLOCK       ----------
import React, { useEffect, useRef } from 'react';
import Quill from 'quill';
//  Import Quill's snow theme CSS
import 'quill/dist/quill.snow.css';
//  ----------      END   IMPORT  BLOCK       ----------

function LaboratoryTests({ placeholder, onTextChange }) {
  //  To store Quill instance
  const quillRef = useRef(null);
  //  To store the editor DOM element
  const editorRef = useRef(null);

  useEffect(() => {
    if (!editorRef.current) return;

    //  Initialize Quill
    const quillInstance = new Quill(editorRef.current, {
      theme: 'snow',
      placeholder: placeholder || 'Start typing...',
      modules: {
        toolbar: false, // No toolbar
      },
    });

    quillRef.current = quillInstance;

    //  Handle text changes
    const handleTextChange = () => {
      const content = quillInstance.getText();
      if (onTextChange) {
        onTextChange(content.trim());
      }
    };

    //  Add text-change event listener
    quillInstance.on('text-change', handleTextChange);

    //  Clean up on unmount
    return () => {
      quillInstance.off('text-change', handleTextChange);
    };
  }, [placeholder, onTextChange]);

  return <div ref={editorRef} style={{ height: '200px' }} />;
}

export default React.memo(LaboratoryTests);